import React from 'react';
import { InputNumber } from 'antd';

export const InputGroup = ({ label, value, onChange, step = 1 }) => (
    <div className="planner-input-group" style={{ width: '140px', marginBottom: '8px' }}>
        <div className="planner-input-label" style={{ fontSize: '12px' }}>{label}</div>
        <div className="planner-input-wrapper">
            <InputNumber
                style={{ width: '100%' }}
                step={step}
                value={value}
                onChange={(val) => onChange(val || 0)}
            />
        </div>
    </div>
);

export const InfoBox = ({ title, meta, sections }) => (
    <div className="planner-info-box">
        <h2 className="planner-info-title">{title}</h2>
        <p className="planner-info-meta">{meta}</p>
        <div className="planner-info-divider"></div>
        {sections.map((s, i) => (
            <div key={i}>
                <h4 className="planner-info-subtitle">{s.title}</h4>
                {s.type === 'formula' ? (
                    <div className="planner-formula" style={{ margin: '12px 0', fontSize: '14px' }}>{s.content}</div>
                ) : (
                    <p className="planner-info-content" dangerouslySetInnerHTML={{ __html: s.content }} />
                )}
            </div>
        ))}
    </div>
);

export const fmtCur = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2 });
export const fmtCurNoDec = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 });
export const fmtNum = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2 });
export const fmtPts = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 1 });
export const formatCurrencyExt = (val) => `₹${fmtCur.format(val)}`;
